import { AnyAction, Reducer } from 'redux';
import { UserRxFormData, GetUserMessage, GetFileData } from './rxForm';

export const STORE_UNDERDESIGNDATA = 'all-data/underdesign-order';
export const STORE_DESIGNREADYDATA = 'all-data/designready-order';
export const STORE_MHOLDORDERDATA = 'all-data/manufactur-hold-order';
export const STORE_MNEWORDERDATA = 'all-data/manufactur-new-order';
export const STORE_MINPRODUCTIONORDERDATA = 'all-data/manufactur-inproduction-order';
export const STORE_MCOMPLETEORDERDATA = 'all-data/manufactur-complete-order';
export const STORE_M_FILTERED_DATA = 'filtered-data/manufactur-order';
export const STORE_M_FILTERLESS_DATA = 'filter-less-data/manufactur-order';
export const STORE_M_FILTER_DATA_EXPORT = 'filter-data/manufactur-order-data-export';
export const STORE_M_PREVIEWORDER_DATA = 'all-data-preview-screen/manufactur-order';

export interface RowDataManufactur {
    rowno: string;
    orderno: string;
    orderdate: string;
    fname: string;
    fpath: string;
    filesize: string;
    feedback: string;
    vfiles: string;
    material: string;
    servicename: string;
    designtype: string;
    tat: string;
    msg: string;
    nounits: string;
    status: string;
    completedon: string;
    final_scan_url: string;
    customerstatus: string;
    mfrstatus: string;
    fdownload: string;
    qc_required: string;
    labname: string;
    casenotes: string;
    customer: string;
    batchno: string;
    iterono: string;
    holdreason: string;
    destination?: string;
}

export interface PreviewOrderData {
    userRxdata: UserRxFormData[];
    getUserMessage: GetUserMessage[];
    getFileData: GetFileData[];
    caseNotes: string;
}

export interface ManufacturState {
    underDesignData: RowDataManufactur[];
    designReadyData: RowDataManufactur[];
    mHoldOrderData: RowDataManufactur[];
    mNewOrderData: RowDataManufactur[];
    mInproductionOrderData: RowDataManufactur[];
    mCompleteOrderData: RowDataManufactur[];
    mfilteredOrderData: RowDataManufactur[];
    mfilterLessOrderData: RowDataManufactur[];
    mfiltersdataExport: RowDataManufactur[];
    previewOrderData: PreviewOrderData;
}

const initialState: ManufacturState = {
    // files: [],
    underDesignData: [],
    designReadyData: [],
    mHoldOrderData: [],
    mNewOrderData: [],
    mInproductionOrderData: [],
    mCompleteOrderData: [],
    mfilteredOrderData: [],
    mfilterLessOrderData: [],
    mfiltersdataExport: [],
    previewOrderData: {
        userRxdata: [],
        getUserMessage: [],
        getFileData: [],
        caseNotes: ''
    }
};

const reducer: Reducer<ManufacturState> = (
    state: ManufacturState = initialState,
    action: AnyAction
): ManufacturState => {
    switch (action.type) {
        case STORE_UNDERDESIGNDATA:
            return {
                ...state,
                underDesignData: action.underDesignData
            };
        case STORE_DESIGNREADYDATA:
            return {
                ...state,
                designReadyData: action.designReadyData
            };
        case STORE_MHOLDORDERDATA:
            return {
                ...state,
                mHoldOrderData: action.mHoldOrderData
            };
        case STORE_MNEWORDERDATA:
            return {
                ...state,
                mNewOrderData: action.mNewOrderData
            };
        case STORE_MINPRODUCTIONORDERDATA:
            return {
                ...state,
                mInproductionOrderData: action.mInproductionOrderData
            };
        case STORE_MCOMPLETEORDERDATA:
            return {
                ...state,
                mCompleteOrderData: action.mCompleteOrderData
            };
        case STORE_M_FILTERED_DATA:
            return {
                ...state,
                mfilteredOrderData: action.mfilteredOrderData
            };
        case STORE_M_FILTERLESS_DATA:
            return {
                ...state,
                mfilterLessOrderData: action.mfilterLessOrderData
            };
        case STORE_M_FILTER_DATA_EXPORT:
            return {
                ...state,
                mfiltersdataExport: action.mfiltersdataExport
            };
        case STORE_M_PREVIEWORDER_DATA:
            return {
                ...state,
                previewOrderData: action.previewOrderData
            };
        default:
            return state;
    }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/manufactur.tsx